import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';
import { CreateCustomDataFieldResponse } from 'models/CustomDataField';
import useAppUser from 'hooks/useAppUser';

export const CREATE_CUSTOM_DATA_FIELD_MUTATION_KEY = 'create-custom-data-field';
export const DELETE_CUSTOM_DATA_FIELD_MUTATION_KEY = 'delete-custom-data-field';

const useCustomDataFieldsMutations = () => {
  const { agencyUid } = useAppUser();

  const { mutateAsync: createCustomField, isLoading: isCreatingCustomField } =
    useAppMutation(
      [CREATE_CUSTOM_DATA_FIELD_MUTATION_KEY],
      ({ name, type }: { name: string; type: string }) => {
        return API.post<CreateCustomDataFieldResponse>(
          '/api/v3.2/custom-data-fields',
          {
            agencyUid,
            name,
            type,
          },
        );
      },
    );

  const { mutateAsync: deleteCustomField, isLoading: isDeletingCustomField } =
    useAppMutation(
      [DELETE_CUSTOM_DATA_FIELD_MUTATION_KEY],
      ({ uid }: { uid: string }) => {
        return API.delete(`/api/v3.2/custom-data-fields/${uid}`);
      },
    );

  return {
    createCustomField,
    isCreatingCustomField,
    deleteCustomField,
    isDeletingCustomField,
  };
};

export default useCustomDataFieldsMutations;
